export const quotationList = "QUOTATION_LIST";
export const quotationHistoryList = "QUOTATION_HISTORY_LIST"
